import React from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { ReportPills } from 'components/common/reportPills/ReportPills';

import { IComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

import classes from './VersionAndPillsWrapper.module.scss';

interface Props {
    widgetViewMode: WidgetViewMode;
    selectedProjectAndContract?: IComponentProps['widgetSelectedProjectAndContract'];
    pills?: unknown[];
    children?: React.ReactNode;
}

export const ReportingVersionAndPills = ({ selectedProjectAndContract, pills, widgetViewMode, children }: Props) => {
    const isInReport = WidgetViewModeUtils.isReportView(widgetViewMode);

    if (!isInReport) return null;

    return (
        <div className={classes.versionAndPillsWrapper}>
            {selectedProjectAndContract ? selectedProjectAndContract : null}
            {pills && pills?.length > 0 ? <ReportPills pills={pills} /> : null}
            {children}
        </div>
    );
};
